/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import classes from "../createPackage.module.css";
import Grid from "@mui/material/Grid";
import Input from "../../../../component/inputpm";
import Button from "../../../../component/button";
import FormControl from "@mui/material/FormControl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { TableContainer, Toolbar, Tooltip } from "@mui/material";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Loader from "../../../../component/loader";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import constants from "../../../../helper/constants";
import BusApiCall from "../../../../helper/axios";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Breadcrumb from "../../../../component/breadcrumb";
import { withTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import {
  DeleteIconNew,
  EditIconNew,
  ViewIconNew,
  PlusIcon,
} from "../../../../component/icons/icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { IconButton } from "@mui/material";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../../helper/withNavigation";

// const styles = {
//     resizablePaper: {
//       resize: 'both',
//       overflow: 'auto',
//       minWidth: 640,
//       minHeight: 200,
//       maxWidth: '90vw',
//       maxHeight: '90vh',
//       width: '60vw',
//     },
//   };

class CreateSpecialPrice extends Component {
  state = {
    promoList: [],
    displayPromoForm: false,
    existingPromo: "",
    promoName: "",
    packageId: "",
    eliteMembers: "all",
    customers: "",
    customerList: [],
    promoDescription: "",
    promoId: "",
    loading: false,
    partnerId: "",
    noOfOpexMonths: 12,
    enableOpexPromo: false,
    bread: [{
      title: this.props.t("EDIT_SPECIAL_PRICING"),
      url: "/myOfferings",
    }],
    disableCustomer: false,
    action: "ADD",
    selectedToDelete: {},
    showConfirmDialog: false,
  };

  constructor(props) {
    super(props);
    this.createPromo = this.createPromo.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    let search = new URLSearchParams(this.props.router.location.search);
    let packageId = search.get("packageId");
    this.props.setErrorMessage("", false);
    this.setState({ loading: true });
    let bread = [...this.state.bread];
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/packagedSolutions/products/${packageId}?packageMode=edit&promoId=null`,
    )
      .then((res) => {
        bread.push({
          title: res.data.basicDetail.productName,
          url:
            this.props.router.location.pathname +
            this.props.router.location.search,
        });
        if (res.data.customer && res.data.customer.length > 0) {
          this.setState({
            customers: res.data.customer[0],
            disableCustomer: true,
          });
        }
        this.setState({
          bread,
          productName: res.data.basicDetail.productName,
          partnerName: res.data.partnerName,
          partnerId: res.data.partnerId,
        });
        this.getPromosList();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/customers/packaged-solutions`,
    )
      .then((res) => {
        //SoapCall("getCustomers", null, null, false, 2).then(res => {
        this.setState({
          customerList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  }

  getPromosList = () => {
    let search = new URLSearchParams(this.props.router.location.search);
    let packageId = search.get("packageId");
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/promos/packaged-solutions/${packageId}`,
    )
      .then((res) => {
        this.setState({
          promoList: res.data,
          displayPromoForm: false,
          disableCustomer: false,
          action: "ADD",
          promoId: "",
          promoName: "",
          promoDescription: "",
          customers: "",
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, displayPromoForm: false });
      });
  };

  createPromo(type) {
    if (
      !this.state.promoName ||
      !this.state.promoDescription ||
      !this.state.customers ||
      !this.state.eliteMembers
    ) {
      this.props.setErrorMessage(
        this.props.t("MANDATORY_FIELDS_MESSAGE"),
        false,
      );
    } else {
      let search = new URLSearchParams(this.props.router.location.search);
      let packageId = search.get("packageId");
      // let partner = search.get("partner");
      let partner = this.state.partnerId;
      this.setState({ packageId: packageId });
      if (type == "existingPromo") {
        this.props.router.navigate(
          "/createPackage?packageId=" +
          packageId +
          "&packageMode=promo&promoId=" +
          this.state.promoId +
          "&promoName=" +
          this.state.promoName,
        );
      } else {
        this.setState({ loading: true });
        //console.log('this.state', this.state)
        setTimeout(
          function () {
            BusApiCall("POST", `${constants.busInternalUrl}/promos`, this.state)
              .then((res) => {
                //SoapCall('createPromoForPartner', this.state, null).then(res => {
                //console.log('check respinse create price', res)
                if (res.data[0].productPromoId) {
                  let promoId = res.data[0].productPromoId;
                  let locaOpexTenureMonths = res.data[0].opexTenureMonths;
                  let localType = res.data[0].type;
                  if (this.state.action) {
                    this.props.setErrorMessage(
                      this.props.t("SPECIAL_PRICE_UPDATED_SUCCESSFULLY"),
                      true,
                    );
                    this.getPromosList();
                  } else if (this.state.action === "DELETE") {
                    this.props.setErrorMessage(
                      this.props.t("SPECIAL_PRICE_DELETED_SUCCESSFULLY"),
                      true,
                    );
                    this.getPromosList();
                  } else {
                    this.props.setErrorMessage(
                      this.props.t("SPECIAL_PRICE_CREATED_SUCCESSFULLY"),
                      true,
                    );
                  }
                  if (localType && "OPEX_PRICING" === localType) {
                    // this.props.history.go(0);
                    this.getPromosList();
                  } else {
                    if (this.state.action === "MODIFY") {
                      this.getPromosList();
                    } else {
                      this.setState({ loading: false });
                      this.props.router.navigate(
                        "/createPackage?packageId=" +
                        packageId +
                        "&packageMode=promo&promoId=" +
                        promoId +
                        "&promoName=" +
                        this.state.promoName +
                        "&partner=" +
                        partner,
                      );
                    }
                  }
                } else {
                  if (this.state.action === "MODIFY") {
                    this.props.setErrorMessage(
                      this.props.t("SPECIAL_PRICE_UPDATED_SUCCESSFULLY"),
                      true,
                    );
                    this.getPromosList();
                  } else if (this.state.action === "DELETE") {
                    this.props.setErrorMessage(
                      this.props.t("SPECIAL_PRICE_DELETED_SUCCESSFULLY"),
                      true,
                    );
                    this.getPromosList();
                  } else {
                    this.setState({ loading: false });
                    if (res.data[0].errorMessage) {
                      this.props.setErrorMessage(
                        res.data[0].errorMessage,
                        false,
                      );
                    } else {
                      this.props.setErrorMessage(
                        this.props.t("DEFAULT_ERROR_MESSAGE"),
                        false,
                      );
                    }
                  }
                }
              })
              .catch((err) => {
                this.setState({ loading: false });
                // this.props.setErrorMessage(err[0].errorMessage, false)
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
              });
          }.bind(this),
          1000,
        );
      }
    }
  }
  onChange = (e) => {
    this.props.setErrorMessage("", false);
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.value === "newPromo") {
      this.setState({
        displayPromoForm: true,
      });
    } else {
      this.setState({
        promoId: e.target.value,
        promoName:
          e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
      });
    }
  };

  onInputChange = (e) => {
    const re = /^[a-zA-Z0-9_-]+$/;
    if (e.target.name == "promoName") {
      if (e.target.value === "" || re.test(e.target.value)) {
        //console.log('true');
        this.setState({
          [e.target.name]: e.target.value,
        });
      }
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  setOpexPricing = (e) => {
    if (e.target.checked) {
      this.setState({
        enableOpexPromo: true,
      });
    } else {
      this.setState({
        enableOpexPromo: false,
      });
    }
  };

  onOpexTenureChange = (event) => {
    const isnum = /^\d+$/.test(event.target.value);
    if (isnum || event.target.value === null || event.target.value === "") {
      let tempNum = parseInt(event.target.value);
      this.setState({
        noOfOpexMonths: tempNum,
      });
    }
  };

  editSpecialPrice(name, id) {
    let search = new URLSearchParams(this.props.router.location.search);
    let packageId = search.get("packageId");
    this.props.router.navigate(
      "/createPackage?packageId=" +
      packageId +
      "&packageMode=promo&promoId=" +
      id +
      "&promoName=" +
      name,
    );
  }

  editPricingDesc = (pricing) => {
    this.setState(
      {
        action: "MODIFY",
        promoId: pricing.id,
        promoName: pricing.name,
        promoDescription: pricing.description,
        customers: pricing.partyId,
        disableCustomer: true,
      },
      () => {
        this.setState({
          displayPromoForm: true,
        });
      },
    );
  };

  deletePricing = (pricing) => {
    this.setState({
      action: "DELETE",
      selectedToDelete: pricing,
      showConfirmDialog: true,
    });
  };

  closeDeleteConfirm = (val) => {
    if (val) {
      var pricing = this.state.selectedToDelete;
      this.setState(
        {
          action: "DELETE",
          promoId: pricing.id,
          promoName: pricing.name,
          promoDescription: pricing.description,
          customers: pricing.partyId,
          disableCustomer: true,
          showConfirmDialog: false,
          loading: true,
        },
        () => {
          this.createPromo();
        },
      );
    } else {
      this.setState({
        action: "ADD",
        selectedToDelete: {},
        showConfirmDialog: false,
      });
    }
  };

  addSpecialPrice() {
    this.setState({
      displayPromoForm: true,
    });
  }
  goBack() {
    this.props.router.navigate("/myOfferings");
  }
  cancelAddnewPrice() {
    this.props.setErrorMessage("", false);
    this.setState({
      displayPromoForm: false,
      promoName: "",
      promoDescription: "",
      eliteMembers: "all",
      customers: "",
      action: "ADD",
    });
  }

  render() {
    const t = this.props.t;
    // const { classes } = this.props;
    return (
      <main>
        {/* <h3 className={classes.customBreadcrumb}>Select Special Price
                        {this.state.partnerName ? ' : ' : ''} {this.state.partnerName}
                        {this.state.productName ? ' : ' : ''} {this.state.productName}
                    </h3> */}
        <Breadcrumb list={this.state.bread} />
        <div
          // className={classes.root}
          style={{ width: '100%', clear: 'both' }}
        >
          {!this.state.displayPromoForm && (
            <Grid container spacing={2} style={{ paddingTop: "2rem" }}>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "1rem",
                  }}
                >
                  <Typography
                    // className={classes.title}
                    variant="h6"
                    id="tableTitle"
                  >
                    {t("SPECIAL_PRICE")}
                  </Typography>
                  <Button onClick={() => this.addSpecialPrice()}>
                    {t("ADD_SPECIAL_PRICE")}
                  </Button>
                </div>
                <Card
                  className="borderOutline roundCorners"
                  variant="outlined"
                  style={{ padding: "0", marginBottom: "1rem" }}
                >
                  <TableContainer>
                    <Table className="roundCorners">
                      <TableHead
                        style={{
                          background: "rgba(196, 196, 196, 0.2)",
                          borderRadius: "10px",
                          fontWeight: 700,
                        }}
                      >
                        <TableRow>
                          <TableCell align="left">
                            <b style={{ paddingLeft: "16px" }}>
                              {t("SPECIAL_PRICE_NAME")}
                            </b>
                          </TableCell>
                          <TableCell align="left">
                            <b style={{ paddingLeft: "16px" }}>{t("TYPE")}</b>
                          </TableCell>
                          <TableCell
                            align="center"
                          // className={classes.featureCodeCell}
                          >
                            <b>{t("ACTION")}</b>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.promoList.map((opt) => (
                          <TableRow key={opt.id}>
                            <TableCell
                              align="left"
                              style={{ paddingLeft: "24px" }}
                            >
                              {opt.name}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{ paddingLeft: "24px" }}
                            >
                              {opt.type && opt.type === "OPEX_PRICING" ? (
                                <span>{t("OPEX_PRICING_TYPE", { opt })}</span>
                              ) : (
                                <span>{t("CUSTOM_PRICING_TYPE")}</span>
                              )}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ paddingRight: "24px" }}
                            >
                              {/* <Button onClick={() =>
                                                                opt.type && opt.type === 'OPEX_PRICING' ?
                                                                    this.props.setErrorMessage(t('EDIT_OPEX_PRICING_NOT_ALLOWED'), false)
                                                                    :
                                                                    this.editSpecialPrice(opt.name, opt.id)
                                                            }>{t('EDIT')}</Button> */}
                              <div
                                style={{
                                  display: "flex",
                                  gap: ".5rem",
                                  justifyContent: "center",
                                }}
                              >
                                <Tooltip title={t("VIEW")}>
                                  <Button
                                    onClick={() =>
                                      opt.type && opt.type === "OPEX_PRICING"
                                        ? this.props.setErrorMessage(
                                          t("EDIT_OPEX_PRICING_NOT_ALLOWED"),
                                          false,
                                        )
                                        : this.editSpecialPrice(
                                          opt.name,
                                          opt.id,
                                        )
                                    }
                                    className="buttonSecondary"
                                  >
                                    <ViewIconNew />
                                  </Button>
                                </Tooltip>
                                <Tooltip title={t("EDIT")}>
                                  <Button
                                    onClick={() => {
                                      this.editPricingDesc(opt);
                                    }}
                                    className="buttonSecondary"
                                  >
                                    <EditIconNew />
                                  </Button>
                                </Tooltip>
                                <Tooltip title={t("DELETE")}>
                                  <Button
                                    onClick={() => {
                                      this.deletePricing(opt);
                                    }}
                                    className="buttonSecondary"
                                  >
                                    <DeleteIconNew />
                                  </Button>
                                </Tooltip>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {this.state.promoList.length == 0 && (
                          <TableRow>
                            <TableCell align="center" colSpan={3}>
                              {t("NO_SPECIAL_PRICING_FOUND")}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
                <Grid
                  // className={classes.backCont}
                  item
                  align="right"
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className={"buttonSecondary"}
                    onClick={() => {
                      this.goBack();
                    }}
                  >
                    {t("BACK")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {this.state.displayPromoForm && (
            <Grid container spacing={2} style={{ paddingTop: "2rem" }}>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <Input
                  // divClass={classes.customDiv}
                  name={"promoName"}
                  value={this.state.promoName}
                  onChange={(event) => this.onInputChange(event)}
                  placeholder={t("SPECIAL_PRICE_NAME") + " *"}
                  variant={"outlined"}
                  size={"small"}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <Input
                  // divClass={classes.customDiv}
                  name={"promoDescription"}
                  value={this.state.promoDescription}
                  onChange={(event) => this.onInputChange(event)}
                  placeholder={t("SPECIAL_PRICE_DESCRIPTION") + " *"}
                  variant={"outlined"}
                  size={"small"}
                />
              </Grid>

              <Grid
                item
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <FormControl
                  variant="outlined"
                  size={"small"}
                >
                  <InputLabel id="selectCustomerLabel">
                    {t("SELECT_CUSTOMERS")} *
                  </InputLabel>
                  <Select
                    native
                    label={t("SELECT_CUSTOMERS") + ' *'}
                    labelId="selectCustomerLabel"
                    value={this.state.customers}
                    onChange={(event) => this.onInputChange(event)}
                    inputProps={{
                      name: "customers",
                      id: "outlined-age-native-simple",
                    }}
                    disabled={this.state.disableCustomer}
                  >
                    <option value="" disabled></option>
                    <option value="all">{t("ALL")}</option>
                    {this.state.customerList.length > 0 &&
                      this.state.customerList.map((opt) => (
                        <option value={opt.partyId} key={opt.partyId}>
                          {opt.partyName}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      // className={classes.opexCheckbox}
                      onChange={(event) => this.setOpexPricing(event)}
                      name={"opexPricing"}
                      color="primary"
                    />
                  }
                  label={t("ENABLE_OPEX_PRICING_FOR_A_TERM_OF")}
                />
                <Input
                  disabled={!this.state.enableOpexPromo}
                  // divClass={classes.tablePriceInput}
                  name={"noOfOpexMonths"}
                  value={this.state.noOfOpexMonths}
                  style={{ width: "60px" }}
                  type={"text"}
                  onChange={(event) => this.onOpexTenureChange(event)}
                />
                <span
                  disabled={!this.state.enableOpexPromo}
                // className={classes.tempNameDiv}
                >
                  &nbsp;&nbsp;{t("MONTHS")}
                </span>
              </Grid>

              <Grid
                item
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                <label className="text-error" style={mandatoryMessage}>
                  {t("MANDATORY_FIELDS_MESSAGE")}
                </label>
              </Grid>

              <Grid
                item
                style={{ display: "flex", justifyContent: "space-between" }}
                size={{
                  xs: 12,
                }}
              >
                <div>
                  <Button
                    className={"buttonSecondary"}
                    onClick={() => {
                      this.cancelAddnewPrice();
                    }}
                  >
                    {t("BACK")}
                  </Button>
                </div>
                {/* </Grid>
                            <Grid item xs={4} className={classes.createPartnerGrid}> */}
                <div>
                  <Button
                    onClick={() => {
                      this.createPromo("newPromo");
                    }}
                  >
                    {this.state.action === "MODIFY"
                      ? t("UPDATE_SPECIAL_PRICE")
                      : t("CREATE_SPECIAL_PRICE")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
        <Dialog
          maxWidth={"md"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={this.state.showConfirmDialog}
          aria-labelledby="delete-dialog-title"
          PaperProps={
            {
              // className: classes.resizablePaper
            }
          }
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            <div style={{ display: "flex" }}>
              <span style={{ display: "inline-flex", width: "95%" }}>
                {t("DELETE")}
              </span>
              <Tooltip title={t("CLOSE")}>
                <IconButton
                  onTouchStart={() => this.closeDeleteConfirm(false)}
                  onClick={() => this.closeDeleteConfirm(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              {t("DELETE_SPECIAL_PRICING_MESSAGE")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.closeDeleteConfirm(false)}
              color="primary"
            >
              {t("NO")}
            </Button>
            <Button
              onClick={(event) => this.closeDeleteConfirm(true)}
              color="primary"
            >
              {t("YES")}
            </Button>
          </DialogActions>
        </Dialog>
        <Loader loading={this.state.loading} />
      </main>
    );
  }
}
const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};
const mandatoryMessage = {
  lineHeight: "64px",
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(CreateSpecialPrice)));
